import { first } from 'lodash';
import { getProductImages } from 'src/components/widget/lineupWidget/editProductPanel/EditProductPanel.helper';
import { ICCAsset, IProduct } from 'src/interfaces';
import { IProductVariation } from 'src/interfaces/Product';

import { getPreviewUrlSrc } from './gcf-helper';

/**
 * Get the preview URL for a product variation
 * @param product - The product data
 * @param variationCode - The variation code to find
 * @returns The preview URL for the variation or group image
 */
export const getProductPreviewUrl = (
  product?: IProduct,
  variationCode?: string,
  assets?: ICCAsset[],
  withoutSrc = false,
): string => {
  if (!product) {
    return '';
  }

  const variations = product.productVariations;
  const groupImageSrc = first(getProductImages(product))?.name;
  const dy_asset = variations?.find(
    (variation: IProductVariation) => variation.product_code === variationCode,
  )?.dy_asset;

  const variationImageSrc = assets?.find(
    (asset) => asset.id === dy_asset,
  )?.name;

  return withoutSrc
    ? variationImageSrc || groupImageSrc || ''
    : getPreviewUrlSrc(variationImageSrc || groupImageSrc);
};
